import React, { useState, useCallback, useEffect, useMemo } from "react";
import {
  View,
  Text,
  ActivityIndicator,
  Platform,
  TextInput,
  Modal,
  TouchableOpacity,
  Button,
} from "react-native";
import { styles } from "../../style/FoundryStyle.js";
import {
  getDatosExcel,
  insertNewTheoreticalTime,
  getListProcesos,
  fullDataPiece,
  setLog,
  getListRefActu,
} from "../../services/ConnectDataBase.js";
import {
  WarningAmber as IconWarning,
  LooksOne as IconFirstTime,
  Refresh as IconRefresh,
} from "@mui/icons-material";
import BuildIcon from "@mui/icons-material/Build";
import { useDispatch, useSelector } from "react-redux";
import { SCREEN_IDS } from "../FullComponent.js";
import { BACKGROUND_COLORS, BORDER_COLORS, TEXT_COLORS, LOADING_COLORS, BRAND_COLORS, INFORMACION_DETALLE_COLORS } from "../../style/colors.js";
import { updateInfoData } from "../../redux/reducers";
import { notify } from "../../services/ui/notify";
import { getArrayInfoDataUpdate } from "../../services/Functions";
import { backgroundColor2 } from "../../constants/Constants.js";
import { translateText } from "../../translations/translationService";
import VistaAvanzadaReferencias from "./ComponentVistaAvanzadaReferencias.js";
import { typeConnect } from "../../constants/Constants.js";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputBase,
  IconButton,
  Select,
  MenuItem,
  Box,
  Skeleton,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";

// Configuración de skeletons de carga
const SKELETON_CONFIG = {
  rows: 8,              // Número de filas de skeletons
  height: 20,           // Altura de los skeletons en px
  widthLabel: "100%",    // Ancho del skeleton de etiqueta
  widthValue: "100%",    // Ancho del skeleton de valor
};

const InformacionEnDetalle = ({ navigation }) => {
  const dispatch = useDispatch();
  const name = useSelector((state) => state.user.name);
  const [selectedTipo, setSelectedTipo] = useState("REPASO");
  const [tiposDisponibles, setTiposDisponibles] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [actualizarValores, setActualizarValores] = useState({});
  const [listProcesos, setListProcesos] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedReferencia, setSelectedReferencia] = useState(null);
  const [modalData, setModalData] = useState([]);
  const [referenciasActualizadas, setReferenciasActualizadas] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [searchTermAvanzado, setSearchTermAvanzado] = useState("");
  const [hasMO8, setHasMO8] = useState({});

  const [modoAvanzado, setModoAvanzado] = useState(false);
  const [detalleDisponible, setDetalleDisponible] = useState({});
  const lang = useSelector((state) => state.lang.value);
  const [fechaInicio, setFechaInicio] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [inputsBloqueados, setInputsBloqueados] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [filterRealSinStand, setFilterRealSinStand] = useState(false);
  const [filterFirstTime, setFilterFirstTime] = useState(false);

  const [datosOriginalesCompletos, setDatosOriginalesCompletos] = useState([]);

  useEffect(() => {
    consultaExcel();
  }, [selectedTipo, fechaInicio]);

  const consultaExcel = async () => {
    setIsLoading(true);
    try {
      const fullPOAndMO = await getDatosExcel(
        "TIEMPOS",
        typeConnect[0],
        SCREEN_IDS.GENERAL
      );

      setDatosOriginalesCompletos(fullPOAndMO.data);

      const datosAgrupados = AgruparDatos(fullPOAndMO.data);
      const tiposUnicos = obtenerTiposUnicos(datosAgrupados);
      setTiposDisponibles(tiposUnicos);
      setTableData(datosAgrupados);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const map = {};
    const procesosPermitidos = ["REPASO", "PULIDO", "BAÑOS", "CALIDAD"];

    const filtrarOutliers = (valores) => {
      if (valores.length < 3) return valores;
      const sorted = [...valores].sort((a, b) => a - b);
      const q1Index = Math.floor(sorted.length * 0.25);
      const q3Index = Math.floor(sorted.length * 0.75);
      const q1 = sorted[q1Index];
      const q3 = sorted[q3Index];
      const iqr = q3 - q1;
      const lowerBound = q1 - 2.5 * iqr;
      const upperBound = q3 + 2.5 * iqr;
      return valores.filter((v) => v >= lowerBound && v <= upperBound);
    };

    tableData.forEach((item) => {
      const refCorta = item.referencia.substring(0, 5);
      const key = `${refCorta}|${item.tipo}`;
      if (!procesosPermitidos.includes(item.tipo)) {
        return;
      }
      const fecha =
        item.fecha_proceso || item.fecha || item.fecha_ini_formateada;
      const tiempoReal = parseFloat(item.duracion) / parseFloat(item.cantidad);
      const tiempoTeorico =
        parseFloat(item.tiempo_teorico) / parseFloat(item.cantidad);
      if (!map[key]) {
        map[key] = {
          existe: true,
          fechas: [fecha],
          tiemposReales: [tiempoReal],
          tiemposTeoricos: [tiempoTeorico],
          datosOriginales: [item],
          totalRegistros: 1,
          tiemposPorMO: {},
        };
      } else {
        if (!map[key].fechas.includes(fecha)) {
          map[key].fechas.push(fecha);
        }
        map[key].tiemposReales.push(tiempoReal);
        map[key].tiemposTeoricos.push(tiempoTeorico);
        map[key].datosOriginales.push(item);
        map[key].totalRegistros++;
      }
      const mo = item.mo;
      if (!map[key].tiemposPorMO[mo]) {
        map[key].tiemposPorMO[mo] = {
          tiempoTotal: 0,
          cantidadTotal: 0,
          registros: 0,
        };
      }
      map[key].tiemposPorMO[mo].tiempoTotal += parseFloat(item.duracion);
      map[key].tiemposPorMO[mo].cantidadTotal += parseFloat(item.cantidad);
      map[key].tiemposPorMO[mo].registros++;
    });

    Object.keys(map).forEach((key) => {
      const tiemposPorMO = map[key].tiemposPorMO;
      const tiemposPorPieza = [];
      Object.values(tiemposPorMO).forEach((mo) => {
        const tiempoPorPieza = mo.tiempoTotal / mo.cantidadTotal;
        tiemposPorPieza.push(tiempoPorPieza);
      });

      const tiemposFiltrados = filtrarOutliers(tiemposPorPieza);

      map[key].mediaReal =
        tiemposFiltrados.length > 0
          ? Math.round(
              tiemposFiltrados.reduce((sum, t) => sum + t, 0) /
                tiemposFiltrados.length
            )
          : 0;
      map[key].totalMOs = Object.keys(tiemposPorMO).length;
      map[key].valoresEliminados =
        tiemposPorPieza.length - tiemposFiltrados.length;

      const tiempos = map[key].tiemposReales;
      const tiemposTeoricos = map[key].tiemposTeoricos;

      const tiemposTeoricosFiltrados = filtrarOutliers(tiemposTeoricos);

      map[key].mediaTeorica =
        tiemposTeoricosFiltrados.length > 0
          ? Math.round(
              tiemposTeoricosFiltrados.reduce((sum, t) => sum + t, 0) /
                tiemposTeoricosFiltrados.length
            )
          : 0;
    });

    setDetalleDisponible(map);
  }, [tableData]);

  useEffect(() => {
    optionList();
    ultimoUpdate();
  }, []);

  const compararFechas = (fecha1, fecha2) => {
    if (!fecha1 || !fecha2) return 0;

    const parseDate = (fechaStr) => {
      const [dd, mm, yyyy] = fechaStr.split("-");
      return new Date(`${yyyy}-${mm}-${dd}`);
    };

    const date1 = parseDate(fecha1);
    const date2 = parseDate(fecha2);

    return date1 - date2;
  };

  const toggleVista = () => {
    setModoAvanzado((prev) => !prev);
  };

  const validateData = async (mo) => {
    if (!mo) return;
    try {
      const dataOk = await fullDataPiece(mo.mo, 2);
      if (dataOk) {
        const infoData = getArrayInfoDataUpdate(dataOk);
        dispatch(updateInfoData(infoData));
        return dataOk;
      }
    } catch (error) {
      console.error(error);
    }
    return null;
  };

  const handleMOCick = async (mo) => {
    try {
      const fullData = await validateData({ mo });
      if (fullData && fullData.mo) {
        setIsModalVisible(false);
        navigation.navigate("Info", { data: fullData });
      } else {
        console.log("No se encontró la propiedad 'mo' en fullData.");
      }
    } catch (error) {
      console.error("Error al procesar la MO:", error);
    }
  };

  const ultimoUpdate = async () => {
    try {
      const referenciasActu = await getListRefActu(
        "getReferenciasActu",
        SCREEN_IDS.GENERAL
      );
      setReferenciasActualizadas(referenciasActu);
    } catch (error) {
      console.error("Error al procesar las referencias:", error);
    }
  };

  const optionList = async () => {
    try {
      const listProcessOption = await getListProcesos(
        "MultipleMOWork",
        0,
        SCREEN_IDS.MULTIPLE_WORK
      );
      const moArraySimplificado = Object.entries(listProcessOption).map(
        ([po, mo]) => ({
          codigo: mo.codigo,
          descripcion: mo.descripcion,
        })
      );
      setListProcesos(moArraySimplificado);
    } catch (error) {
      console.error(error);
    }
  };

  const agruparLineasModal = (datos) => {
    const agrupado = {};

    datos.forEach((item) => {
      const key = `${item.referencia}-${item.po}-${item.mo}-${item.usuario}-${item.tipo}`;
      if (!agrupado[key]) {
        agrupado[key] = {
          ...item,
          duracion: Number(item.duracion),
          tiempo_teorico: Number(item.tiempo_teorico),
          cantidad: Number(item.cantidad),
        };
      } else {
        agrupado[key].duracion += Number(item.duracion);
        agrupado[key].tiempo_teorico = Number(item.tiempo_teorico);
        agrupado[key].cantidad = Number(item.cantidad);
      }
    });

    return Object.values(agrupado);
  };

  const crearEstructuraConTotales = (datosAgrupados) => {
    // Primero agrupamos por MO
    const gruposPorMO = {};

    datosAgrupados.forEach((item) => {
      const mo = item.mo;
      if (!gruposPorMO[mo]) {
        gruposPorMO[mo] = [];
      }
      gruposPorMO[mo].push(item);
    });

    // Ahora creamos un array con las líneas individuales y los totales
    const resultado = [];

    Object.entries(gruposPorMO).forEach(([mo, items]) => {
      // Determinar si este grupo tendrá total (2 o más líneas)
      const tieneTotal = items.length >= 2;

      // Agregar todas las líneas individuales del MO
      items.forEach((item, index) => {
        resultado.push({
          ...item,
          esFila: true,
          mo: mo,
          // NUEVO: Marcar específicamente las líneas que se suman
          esLineaSumada: tieneTotal, // Solo true si esta línea se sumará en un total
          perteneceAGrupo: tieneTotal, // Para mantener compatibilidad
          posicionEnGrupo: index,
          totalLineasGrupo: items.length,
        });
      });

      // Solo agregar fila de TOTAL si hay 2 o más líneas para este MO
      if (tieneTotal) {
        const totalDuracion = items.reduce(
          (sum, item) => sum + Number(item.duracion),
          0
        );

        const cantidadPieza = Number(items[0].cantidad);

        const totalTiempoTeorico = Number(items[0].tiempo_teorico);

        resultado.push({
          mo: mo,
          referencia: "TOTAL:",
          usuario: "",
          tipo: items[0].tipo,
          duracion: totalDuracion,
          cantidad: cantidadPieza,
          tiempo_teorico: totalTiempoTeorico,
          fecha_ini_formateada: "",
          fecha_fin_formateada: "",
          esTotal: true,
          esLineaSumada: false,
          perteneceAGrupo: false,
        });
      }
    });

    return resultado;
  };

  const groupedModalData = agruparLineasModal(modalData);
  const modalDataConTotales = crearEstructuraConTotales(groupedModalData);


  const AgruparDatos = (datos) => {
    const acc = new Map();

    datos.forEach((item) => {
      const key = `${item.referencia}-${item.tipo}-${item.mo}`;

      if (acc.has(key)) {
        const existente = acc.get(key);

        // Acumular valores numéricos
        existente.minReal += parseFloat(item.minReal);
        existente.minStand += parseFloat(item.minStand);
        existente.minExtra += parseFloat(item.minExtra);
        existente.duracion += parseFloat(item.duracion);

        // NUEVO: Mantener array de TODAS las fechas
        const fechaItem =
          item.fecha_proceso || item.fecha || item.fecha_ini_formateada;
        if (fechaItem && !existente.todasLasFechas.includes(fechaItem)) {
          existente.todasLasFechas.push(fechaItem);
        }

        // Mantener la fecha más reciente solo para display
        const fechaExistente =
          existente.fecha_proceso ||
          existente.fecha ||
          existente.fecha_ini_formateada;
        if (
          fechaItem &&
          (!fechaExistente || compararFechas(fechaItem, fechaExistente) > 0)
        ) {
          existente.fecha_proceso = item.fecha_proceso;
          existente.fecha = item.fecha;
          existente.fecha_ini_formateada = item.fecha_ini_formateada;
          existente.fecha_fin_formateada = item.fecha_fin_formateada;
          existente.usuario = item.usuario;
        }
      } else {
        // Primer elemento del grupo
        const fechaItem =
          item.fecha_proceso || item.fecha || item.fecha_ini_formateada;
        acc.set(key, {
          ...item,
          cantidad: parseFloat(item.cantidad),
          minReal: parseFloat(item.minReal),
          minStand: parseFloat(item.minStand),
          minExtra: parseFloat(item.minExtra),
          duracion: parseFloat(item.duracion),
          todasLasFechas: fechaItem ? [fechaItem] : [], // Array de fechas
        });
      }
    });

    return Array.from(acc.values());
  };

  const obtenerTiposUnicos = (datos) => {
    const tipos = new Set();
    datos.forEach((item) => tipos.add(item.tipo));
    return Array.from(tipos);
  };

  const obtenerValoresActualizados = async () => {
    try {
      const valoresConTipo = {
        tipo: selectedTipo,
        valores: actualizarValores,
      };
      const procesoSeleccionado = listProcesos.find(
        (proceso) => proceso.descripcion === selectedTipo
      );
      if (!procesoSeleccionado) {
        console.error("No se encontró el código para el tipo seleccionado");
        return;
      }
      const codigoTipo = procesoSeleccionado.codigo;

      await Promise.all(
        Object.entries(valoresConTipo.valores).map(
          async ([referencia, inputValue]) => {
            if (inputValue) {
              const item = datosOrdenados.find(
                (item) => item.referencia === referencia
              );
              if (item) {
                await insertNewTheoreticalTime(
                  "insertTheoreticaltime",
                  SCREEN_IDS.GENERAL,
                  referencia,
                  codigoTipo,
                  inputValue
                );
              }
              setLog(
                SCREEN_IDS.GENERAL,
                "LOG",
                "CambioTiempos",
                "Usuario: " +
                  name +
                  " tiempo: " +
                  inputValue +
                  " Referencia: " +
                  referencia
              );

              setInputsBloqueados((prev) => ({
                ...prev,
                [referencia]: true,
              }));

              setReferenciasActualizadas((prev) => {
                const nuevaReferencia = {
                  referencia: referencia,
                  codigo: codigoTipo,
                  numeropiedras: parseFloat(inputValue),
                  fecha: {
                    date: new Date().toISOString().split("T")[0],
                  },
                };
                const filtradas = prev.filter(
                  (ref) =>
                    !(
                      ref.referencia === referencia && ref.codigo === codigoTipo
                    )
                );
                return [...filtradas, nuevaReferencia];
              });
            }
          }
        )
      );

      setActualizarValores({});
      notify.success("Datos enviados correctamente");
    } catch (error) {
      console.error("Error al enviar los datos:", error);
      notify.error("Error al enviar los datos, por favor inténtalo de nuevo.");
    }
  };

  const handleTipoChange = (value) => {
    setSelectedTipo(value);
  };

  const handleActualizarChange = (referencia, value) => {
    setActualizarValores((prev) => ({
      ...prev,
      [referencia]: value,
    }));
  };

  const filtrarPorBusqueda = useCallback(
    (items) => {
      if (!searchTerm.trim()) return items;
      const term = searchTerm.trim().toLowerCase();
      return items.filter((item) =>
        item.referencia.toLowerCase().includes(term)
      );
    },
    [searchTerm]
  );

  const filtrarPorFecha = useCallback(
    (item) => {
      const fechaSeleccionada = fechaInicio
        ? new Date(fechaInicio)
        : new Date();

      // Si tiene array de fechas, verificar si alguna coincide
      if (item.todasLasFechas && item.todasLasFechas.length > 0) {
        return item.todasLasFechas.some((fecha) => {
          if (!fecha) return false;
          const [dd, mm, yyyy] = fecha.split("-");
          const fechaFormateada = new Date(`${yyyy}-${mm}-${dd}`);
          return (
            fechaFormateada.getFullYear() === fechaSeleccionada.getFullYear() &&
            fechaFormateada.getMonth() === fechaSeleccionada.getMonth() &&
            fechaFormateada.getDate() === fechaSeleccionada.getDate()
          );
        });
      }

      // Fallback para compatibilidad
      const fechaItem =
        item.fecha_proceso || item.fecha || item.fecha_ini_formateada;
      if (fechaItem) {
        const [dd, mm, yyyy] = fechaItem.split("-");
        const fechaFormateada = new Date(`${yyyy}-${mm}-${dd}`);
        return (
          fechaFormateada.getFullYear() === fechaSeleccionada.getFullYear() &&
          fechaFormateada.getMonth() === fechaSeleccionada.getMonth() &&
          fechaFormateada.getDate() === fechaSeleccionada.getDate()
        );
      }

      return true;
    },
    [fechaInicio]
  );

  const datosFiltrados = useMemo(() => {
    const filtradosPorTipoYFecha = tableData.filter(
      (item) => item.tipo === selectedTipo && filtrarPorFecha(item)
    );
    return filtrarPorBusqueda(filtradosPorTipoYFecha);
  }, [tableData, selectedTipo, filtrarPorFecha, filtrarPorBusqueda]);

  useEffect(() => {
    const map = {};
    for (const item of datosFiltrados) {
      if (item.mo?.startsWith("8")) {
        const ref = item.referencia.substring(0, 5);
        map[ref] = true;
      }
    }
    setHasMO8(map);
  }, [datosFiltrados]);

  const datosConMinExtra = useMemo(() => {
    return datosFiltrados.map((item) => {
      const minRealPorUnidad = item.duracion / item.cantidad;
      const minStandPorUnidad = item.tiempo_teorico / item.cantidad;
      const effValue =
        ((minRealPorUnidad - minStandPorUnidad) / minStandPorUnidad) * 100;

      const eficiencia = isFinite(effValue)
        ? `${effValue.toFixed(2)} %`
        : "N/A";
      const numericEficiencia = isFinite(effValue) ? effValue : Infinity;

      return {
        referencia: item.referencia,
        cantidad: parseFloat(item.cantidad).toFixed(2),
        minReal: minRealPorUnidad.toFixed(2),
        minStand: minStandPorUnidad.toFixed(2),
        minExtra: (minRealPorUnidad - minStandPorUnidad).toFixed(2),
        eficiencia,
        numericEficiencia,
        fecha: item.fecha_proceso || item.fecha || item.fecha_ini_formateada,
        mo: item.mo,
      };
    });
  }, [datosFiltrados]);

  const datosOrdenados = useMemo(() => {
    return [...datosConMinExtra].sort(
      (a, b) => b.numericEficiencia - a.numericEficiencia
    );
  }, [datosConMinExtra]);

  const handleRowClick = (referencia) => {
    setSelectedReferencia(referencia);
    setSelectedRow(referencia);

    const filteredData = datosOriginalesCompletos.filter(
      (item) =>
        item.referencia?.substring(0, 5) === referencia.substring(0, 5) &&
        item.tipo === selectedTipo
    );

    console.log("=== DEBUG FECHAS EN MODAL ===");
    console.log("Referencia seleccionada:", referencia);
    console.log("Datos filtrados para modal:", filteredData);

    // Mostrar todas las fechas que tienen los datos originales
    filteredData.forEach((item, index) => {
      console.log(`Item ${index}:`, {
        referencia: item.referencia,
        usuario: item.usuario,
        fecha_ini_formateada: item.fecha_ini_formateada,
        fecha_fin_formateada: item.fecha_fin_formateada,
        fecha_proceso: item.fecha_proceso,
        fecha: item.fecha,
        // Mostrar TODAS las propiedades relacionadas con fecha
        todasLasFechas: Object.keys(item).filter((key) =>
          key.includes("fecha")
        ),
      });
    });

    const sortedData = filteredData.sort((a, b) => {
      const parseDate = (fechaStr) => {
        if (!fechaStr || typeof fechaStr !== "string") return new Date(0);
        const [dd, mm, yyyy] = fechaStr.split("-");
        return new Date(`${yyyy}-${mm}-${dd}`);
      };

      const dateA = parseDate(a.fecha_ini_formateada);
      const dateB = parseDate(b.fecha_ini_formateada);

      return dateB - dateA;
    });


    setModalData(sortedData);
    setIsModalVisible(true);
  };

  const handleChildOpenModal = (referencia, proceso) => {
    setSelectedReferencia(referencia);
    const prefijo = referencia.substring(0, 5);

    const filteredData = datosOriginalesCompletos.filter(
      (item) =>
        item.referencia.substring(0, 5) === prefijo && item.tipo === proceso
    );

    if (filteredData.length === 0) {
      notify.info("No hay datos para esta referencia y proceso");
      return;
    }

    const sortedData = filteredData.sort((a, b) => {
      const parseDate = (fechaStr) => {
        if (typeof fechaStr !== "string") return new Date(0);
        const [dd, mm, yyyy] = fechaStr.split("-");
        return new Date(`${yyyy}-${mm}-${dd}`);
      };
      return (
        parseDate(b.fecha_ini_formateada) - parseDate(a.fecha_ini_formateada)
      );
    });

    setModalData(sortedData);
    setIsModalVisible(true);
  };

  const renderRows = () => {
    return datosOrdenados.map((item, idx) => {
      const procesoSeleccionado = listProcesos.find(
        (proceso) => proceso.descripcion === selectedTipo
      );

      const codigoTipo = procesoSeleccionado?.codigo;

      const prefijo = item.referencia.substring(0, 5);

      const isActualizada = referenciasActualizadas.some(
        (ref) =>
          ref.referencia.substring(0, 5) === prefijo &&
          ref.codigo === codigoTipo
      );

      const referenciaActualizada = referenciasActualizadas.find(
        (ref) =>
          ref.referencia.substring(0, 5) === prefijo &&
          ref.codigo === codigoTipo
      );

      const placeholderFecha = isActualizada
        ? `${parseFloat(referenciaActualizada.numeropiedras).toFixed(1)} | ${
            new Date(referenciaActualizada.fecha.date)
              .toISOString()
              .split("T")[0]
          }`
        : "Subido";
      const isInputBloqueado = inputsBloqueados[item.referencia];
      const isSelected = item.referencia === selectedRow;

      return (
        <TableRow
          key={`${item.referencia}-${item.mo}-${idx}`}
          style={{
            backgroundColor: isSelected ? INFORMACION_DETALLE_COLORS.BACKGROUND_ROW_SELECTED : BACKGROUND_COLORS.CARD,
          }}>
          <TableCell
            style={{
              position: "relative",
              textAlign: "center",
              cursor: "pointer",
              padding: "4px 8px",
              fontSize: "14px",
              lineHeight: 1.2,
            }}
            onClick={() => handleRowClick(item.referencia)}>
            {hasMO8[item.referencia.substring(0, 5)] && (
              <BuildIcon
                fontSize='small'
                style={{
                  position: "absolute",
                  left: 8,
                  color: TEXT_COLORS.SECONDARY,
                }}
                titleAccess='Reparación'
              />
            )}
            {item.referencia}
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              padding: "4px 8px",
              fontSize: "14px",
              lineHeight: 1.2,
            }}>
            {item.cantidad}
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              padding: "4px 8px",
              fontSize: "14px",
              lineHeight: 1.2,
            }}>
            {item.minReal}
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              padding: "4px 8px",
              fontSize: "14px",
              lineHeight: 1.2,
            }}>
            {item.minStand}
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              padding: "4px 8px",
              fontSize: "14px",
              lineHeight: 1.2,
            }}>
            {item.minExtra}
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              padding: "4px 8px",
              fontSize: "14px",
              lineHeight: 1.2,
            }}>
            {item.eficiencia}
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              padding: "4px 8px",
              fontSize: "14px",
              lineHeight: 1.2,
            }}>
            <input
              type='text'
                              style={{
                  height: "30px",
                  width: 150,
                  textAlign: "center",
                  backgroundColor:
                    isActualizada || isInputBloqueado ? BORDER_COLORS.LIGHT : BACKGROUND_COLORS.CARD,
                  border: `1px solid ${BORDER_COLORS.MEDIUM}`,
                  borderRadius: "4px",
                  fontSize: "14px",
                  boxSizing: "border-box",
                }}
                placeholder={isActualizada ? placeholderFecha : "0"}
                value={actualizarValores[item.referencia] || ""}
                onChange={(e) =>
                  handleActualizarChange(item.referencia, e.target.value)
                }
                disabled={isInputBloqueado}
              />
            </TableCell>
          </TableRow>
        );
      });
    };

    return (
        <View style={styles.containerRepairScreen}>
          <View style={styles.tableRepairScreen}>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
                padding: 10,
                backgroundColor: INFORMACION_DETALLE_COLORS.BACKGROUND_TABLE_HEADER,
                borderRadius: 10,
                marginTop: -15,
                shadowColor: INFORMACION_DETALLE_COLORS.SHADOW_DARK,
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.2,
                shadowRadius: 2,
                elevation: 3,
              }}>
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                {/* Botón siempre visible */}
                <TouchableOpacity
                  style={{
                    backgroundColor: modoAvanzado ? INFORMACION_DETALLE_COLORS.TEXT_MUTED : backgroundColor2,
                    paddingVertical: 10,
                    paddingHorizontal: 15,
                    borderRadius: 5,
                    marginLeft: 10,
                    marginRight: 10,
                    justifyContent: "center",
                  }}
                  onPress={toggleVista}>
                  <Text style={{ color: "white", fontWeight: "bold" }}>
                    {modoAvanzado
                      ? "Volver a Vista Normal"
                      : "Procesos por Referencia"}
                  </Text>
                </TouchableOpacity>

                {modoAvanzado && (
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    {/* Formulario de búsqueda */}
                    <Paper
                      component='form'
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: 200,
                        height: 40,
                        mr: 2,
                        backgroundColor: "white",
                        borderRadius: 1,
                      }}>
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder={translateText("Buscar ref.", lang)}
                        value={searchTermAvanzado}
                        onChange={(e) => setSearchTermAvanzado(e.target.value)}
                      />
                      <IconButton type='submit'>
                        <SearchIcon />
                      </IconButton>
                    </Paper>

                    {/* Contenedor de filtros */}
                    <Box sx={{ display: "flex", alignItems: "center", ml: 1 }}>
                      <IconButton
                        onClick={() => setFilterRealSinStand((f) => !f)}
                        color={filterRealSinStand ? "error" : "default"}
                        title='Real sin estándar'>
                        <IconWarning />
                      </IconButton>
                      <IconButton
                        onClick={() => setFilterFirstTime((f) => !f)}
                        color={filterFirstTime ? "primary" : "default"}
                        title='Primera vez'>
                        <IconFirstTime />
                      </IconButton>
                      <IconButton
                        onClick={consultaExcel}
                        color='default'
                        title='Recargar datos'
                        disabled={isLoading}>
                        <IconRefresh
                          style={{
                            animation: isLoading
                              ? "spin 1s linear infinite"
                              : "none",
                          }}
                        />
                      </IconButton>
                    </Box>
                  </View>
                )}

                {/* Solo visible si no estamos en modo avanzado */}
                {!modoAvanzado && (
                  <>
                    {/* Buscador */}
                    <Paper
                      component='form'
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: 200,
                        height: 40,
                        mr: 2,
                        backgroundColor: "white",
                        borderRadius: "4px",
                        boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                      }}
                      onSubmit={(e) => {
                        e.preventDefault();
                      }}>
                      <InputBase
                        sx={{ ml: 1, flex: 1, height: "100%" }}
                        placeholder={translateText("Buscar ref.", lang)}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      <IconButton type='submit' sx={{ p: "10px" }}>
                        <SearchIcon />
                      </IconButton>
                    </Paper>

                    {/* Selector de tipo */}
                    <Paper
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: 200,
                        height: 40,
                        mr: 2,
                        backgroundColor: "white",
                        borderRadius: "4px",
                        boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                      }}>
                      <Select
                        value={selectedTipo}
                        onChange={(e) => handleTipoChange(e.target.value)}
                        sx={{
                          flex: 1,
                          height: "100%",
                          "& .MuiSelect-select": {
                            display: "flex",
                            alignItems: "center",
                            padding: "8px",
                          },
                        }}
                        displayEmpty>
                        {tiposDisponibles.map((tipo, index) => (
                          <MenuItem key={index} value={tipo}>
                            {translateText(tipo, lang)}
                          </MenuItem>
                        ))}
                      </Select>
                    </Paper>

                    {/* Selector de fecha */}
                    <Paper
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: 200,
                        height: 40,
                        backgroundColor: "white",
                        borderRadius: "4px",
                        boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                      }}>
                      <InputBase
                        type='date'
                        value={fechaInicio}
                        onChange={(e) => setFechaInicio(e.target.value)}
                        sx={{
                          flex: 1,
                          height: "100%",
                          padding: "8px",
                        }}
                      />
                    </Paper>
                  </>
                )}
              </View>

              {/* Botón de subir tiempos, también oculto en modo avanzado */}
              {!modoAvanzado && (
                <TouchableOpacity
                  style={{
                    backgroundColor: backgroundColor2,
                    paddingVertical: 10,
                    paddingHorizontal: 20,
                    borderRadius: 5,
                    alignItems: "flexEnd",
                    justifyContent: "center",
                    marginLeft: 20,
                    cursor: "pointer",
                  }}
                  onPress={obtenerValoresActualizados}>
                  <Text
                    style={{
                      color: INFORMACION_DETALLE_COLORS.TEXT_LIGHT,
                      fontWeight: "bold",
                      fontSize: 16,
                      marginHorizontal: 10,
                    }}>
                    {translateText("Subir Tiempos", lang)}
                  </Text>
                </TouchableOpacity>
              )}
            </View>

            {isLoading ? (
              <TableContainer component={Paper} style={{ maxHeight: "69vh" }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow style={{ backgroundColor: INFORMACION_DETALLE_COLORS.BACKGROUND_TABLE_HEADER }}>
                      {[
                        translateText("Referencia", lang),
                        translateText("Cantidad", lang),
                        "Min Real",
                        "Min Stand",
                        "Min Extra",
                        translateText("Ineficiencia", lang) + "(%)",
                        translateText("Actualizar", lang),
                      ].map((header, i) => (
                        <TableCell
                          key={i}
                          style={{ textAlign: "center", fontWeight: "bold" }}>
                          <Skeleton variant="text" width="80%" height={20} sx={{ bgcolor: "rgba(255,255,255,0.3)", mx: "auto" }} />
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[...Array(SKELETON_CONFIG.rows)].map((_, rowIndex) => (
                      <TableRow
                        key={rowIndex}
                        style={{
                          backgroundColor: rowIndex % 2 === 0 ? "#ffffff" : INFORMACION_DETALLE_COLORS.BACKGROUND_ROW_ALTERNATE || "#f5f5f5",
                        }}>
                        {[...Array(7)].map((_, colIndex) => (
                          <TableCell
                            key={colIndex}
                            style={{
                              textAlign: "center",
                              padding: "4px 8px",
                            }}>
                            <Skeleton variant="text" width={SKELETON_CONFIG.widthValue} height={SKELETON_CONFIG.height} />
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : modoAvanzado ? (
              <VistaAvanzadaReferencias
                searchTerm={searchTermAvanzado}
                setSearchTerm={setSearchTermAvanzado}
                filterRealSinStand={filterRealSinStand}
                filterFirstTime={filterFirstTime}
                referenciasActualizadas={referenciasActualizadas}
                detalleDisponible={detalleDisponible}
                onOpenModal={handleChildOpenModal}
              />
            ) : (
              <>
                <TableContainer component={Paper} style={{ maxHeight: "69vh" }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow style={{ backgroundColor: INFORMACION_DETALLE_COLORS.BACKGROUND_TABLE_HEADER }}>
                        <TableCell
                          style={{ textAlign: "center", fontWeight: "bold" }}>
                          {translateText("Referencia", lang)}
                        </TableCell>
                        <TableCell
                          style={{ textAlign: "center", fontWeight: "bold" }}>
                          {translateText("Cantidad", lang)}
                        </TableCell>
                        <TableCell
                          style={{ textAlign: "center", fontWeight: "bold" }}>
                          Min Real
                        </TableCell>
                        <TableCell
                          style={{ textAlign: "center", fontWeight: "bold" }}>
                          Min Stand
                        </TableCell>
                        <TableCell
                          style={{ textAlign: "center", fontWeight: "bold" }}>
                          Min Extra
                        </TableCell>
                        <TableCell
                          style={{ textAlign: "center", fontWeight: "bold" }}>
                          {translateText("Ineficiencia", lang)}(%)
                        </TableCell>
                        <TableCell
                          style={{ textAlign: "center", fontWeight: "bold" }}>
                          {translateText("Actualizar", lang)}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>{renderRows()}</TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
          </View>

          <Modal
            visible={isModalVisible}
            transparent={true}
            animationType='fade'
            onRequestClose={() => setIsModalVisible(false)}>
            <View
              style={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0,0,0,0.5)",
              }}>
              <View
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  borderRadius: 10,
                  width: "90%",
                  maxHeight: "90%",
                  display: "flex",
                  flexDirection: "column",
                }}>
                <Text
                  style={{
                    fontSize: 18,
                    fontWeight: "bold",
                    marginBottom: 10,
                    textAlign: "center",
                  }}>
                  {translateText("Detalles de la referencia", lang)}:{" "}
                  {selectedReferencia}
                </Text>

                {modalData.length === 0 ? (
                  <ActivityIndicator size='large' color={LOADING_COLORS.PROGRESS} />
                ) : (
                  <View style={{ flex: 1, overflowY: "auto" }}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow style={{ backgroundColor: INFORMACION_DETALLE_COLORS.BACKGROUND_ROW_ALTERNATE }}>
                          <TableCell style={{ textAlign: "center" }}>
                            {translateText("Referencia", lang)}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>MO</TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {translateText("Usuario", lang)}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {translateText("Tipo", lang)}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {translateText("T. Total", lang)}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {translateText("Unidades", lang)}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {translateText("Min Uni Real", lang)}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {translateText("Min Uni Stand", lang)}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {translateText("Fecha Inicio", lang)}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {translateText("Fecha Fin", lang)}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {modalDataConTotales.map((item, index) => {
                          const [dd, mm, yyyy] = item.fecha_ini_formateada
                            ? item.fecha_ini_formateada.split("-")
                            : ["", "", ""];
                          const iso = dd && mm && yyyy ? `${yyyy}-${mm}-${dd}` : "";
                          const isSameDate = iso === fechaInicio;

                          // Función para obtener el color según el grupo (MO)
                          const getGroupColor = (mo) => {
                            const colors = [
                              INFORMACION_DETALLE_COLORS.PALETTE_RED_LIGHT, // Rojo claro
                              INFORMACION_DETALLE_COLORS.PALETTE_GREEN_LIGHT, // Verde claro
                              INFORMACION_DETALLE_COLORS.PALETTE_BLUE_LIGHT, // Azul claro
                              INFORMACION_DETALLE_COLORS.PALETTE_ORANGE_LIGHT, // Naranja claro
                              INFORMACION_DETALLE_COLORS.PALETTE_PURPLE_LIGHT, // Púrpura claro
                              INFORMACION_DETALLE_COLORS.PALETTE_TURQUOISE_LIGHT, // Turquesa claro
                              INFORMACION_DETALLE_COLORS.PALETTE_PINK_LIGHT, // Rosa claro
                              INFORMACION_DETALLE_COLORS.PALETTE_LIME_LIGHT, // Verde lima claro
                              INFORMACION_DETALLE_COLORS.PALETTE_INDIGO_LIGHT, // Índigo claro
                              INFORMACION_DETALLE_COLORS.PALETTE_YELLOW_LIGHT, // Amarillo claro
                            ];

                            let hash = 0;
                            for (let i = 0; i < mo.length; i++) {
                              const char = mo.charCodeAt(i);
                              hash = (hash << 5) - hash + char;
                              hash = hash & hash;
                            }

                            return colors[Math.abs(hash) % colors.length];
                          };

                          // Determinar el color de fondo según el tipo de fila
                          let backgroundColor = "white";
                          let tipoFila = "individual";

                          if (item.esTotal) {
                            // TIPO 1: Filas de TOTAL
                            backgroundColor = INFORMACION_DETALLE_COLORS.BACKGROUND_ROW_HOVER;
                            tipoFila = "total";
                          } else if (item.esLineaSumada) {
                            // TIPO 2: Filas que se suman para el total
                            backgroundColor = isSameDate
                              ? INFORMACION_DETALLE_COLORS.BACKGROUND_ROW_SAME_DATE
                              : getGroupColor(item.mo);
                            tipoFila = "sumada";
                          } else {
                            // TIPO 3: Filas individuales (no se suman)
                            backgroundColor = isSameDate ? INFORMACION_DETALLE_COLORS.BACKGROUND_ROW_SAME_DATE : "white";
                            tipoFila = "individual";
                          }

                          // Estilos diferentes para cada tipo de fila
                          const rowStyle = {
                            backgroundColor: backgroundColor,
                          };

                          const textStyle = {
                            color: item.esTotal ? "white" : "black",
                            fontWeight: item.esTotal ? "bold" : "normal",
                            textAlign: "center",
                          };

                          return (
                            <TableRow key={index} style={rowStyle}>
                              <TableCell style={textStyle}>
                                {item.referencia}
                              </TableCell>
                              <TableCell
                                style={{
                                  ...textStyle,
                                  textDecoration: item.esTotal
                                    ? "none"
                                    : "underline",
                                  cursor: item.esTotal ? "default" : "pointer",
                                }}
                                onClick={() =>
                                  !item.esTotal && handleMOCick(item.mo)
                                }>
                                {item.mo}
                              </TableCell>
                              <TableCell style={textStyle}>
                                {item.usuario}
                              </TableCell>
                              <TableCell style={textStyle}>{item.tipo}</TableCell>
                              <TableCell style={textStyle}>
                                {item.duracion}
                              </TableCell>
                              <TableCell style={textStyle}>
                                {item.cantidad}
                              </TableCell>
                              <TableCell style={textStyle}>
                                {item.cantidad > 0
                                  ? (item.duracion / item.cantidad).toFixed(2)
                                  : "0.00"}
                              </TableCell>
                              <TableCell style={textStyle}>
                                {item.cantidad > 0
                                  ? (item.tiempo_teorico / item.cantidad).toFixed(2)
                                  : "0.00"}
                              </TableCell>
                              <TableCell style={textStyle}>
                                {item.fecha_ini_formateada}
                              </TableCell>
                              <TableCell style={textStyle}>
                                {item.fecha_fin_formateada}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </View>
                )}

                <View style={{ marginTop: 10 }}>
                  <Button
                    title='Cerrar'
                    color={INFORMACION_DETALLE_COLORS.TEXT_BRAND}
                    onPress={() => setIsModalVisible(false)}
                  />
                </View>
              </View>
            </View>
          </Modal>
        </View>
      );
    };

    export default InformacionEnDetalle;
